// API configuration
export const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:2214";

export const API_ENDPOINTS = {
  // Auth endpoints
  LOGIN: `${API_BASE_URL}/api/auth/login`,
  LOGOUT: `${API_BASE_URL}/api/auth/logout`,
  VERIFY_TOKEN: `${API_BASE_URL}/api/auth/verify-token`,

  // Health endpoint
  HEALTH: `${API_BASE_URL}/api/health`,

  // Pipeline endpoints
  PIPELINES: `${API_BASE_URL}/api/pipeline`,

  // Prompt endpoints
  PROMPTS: `${API_BASE_URL}/api/prompts/summary`,

  // Spreadsheet endpoints
  SPREADSHEET: `${API_BASE_URL}/api/spreadsheet`,
  SPREADSHEET_BY_ID: (id: string) => `${API_BASE_URL}/api/spreadsheet/${id}`,
  SPREADSHEET_WORKSHEETS: `${API_BASE_URL}/api/spreadsheet/worksheets`,
} as const;
